export default "__VITE_ASSET__C8c71mMd__"